import React from "react";
import HcsControl from "./hcs-control";

export default class HcsButton extends HcsControl {
    constructor(props) {
        super(props);

        this.state = {
            disabled: false
        };

        this.buttonClick = this.buttonClick.bind(this);
    }

    buttonClick(event) { }

    buttonText() {
        const { data } = this.props;

        return data.info.trans;
    }

    isVisible() {
        return super.isVisible();
    }

    buttonClasses() {
        const { data } = this.props;

        let inputClasses = ["hcs-button", "hcs-primary"];

        if(data.info.focused) {
            inputClasses.push("hcs-focused");
        }

        return inputClasses;
    }

    /**
     * Make button enabled.
     */
    enable() {
        this.setState({
            disabled: false
        });
    }

    /**
     * Make button disabled.
     */
    disable() {
        this.setState({
            disabled: true
        });
    }

    _buttonClassString() {
        const buttonClasses = this.buttonClasses();

        return buttonClasses.length > 0 ? buttonClasses.join(" ") : null;
    }

    render() {
        return super.render(
            <button
                type="button"
                className={this._buttonClassString()}
                onClick={this.buttonClick}
                disabled={this.state.disabled}
                dangerouslySetInnerHTML={{ __html: this.buttonText() }}
            />);
    }
}
